import { useShareToken } from '../hooks/useShareToken';
import { useFirebaseDoc } from '../hooks/firebaseHooks';
import { Invoice } from '../models/shared/Invoice';
import { COLLECTIONS } from '../utils/shared/constants';
import { Container } from 'react-bootstrap';
import { Deal } from '../models/shared/Deal';
import { UnAuthOrganizationContextProvider } from '../context/OrganizationContext';
import OrgCustomerCard from '../components/OrgCustomerCard';
import LineItemsEditor from '../components/LineItemsEditor';
import InvoiceState from '../components/InvoiceState';
import { useText } from '../context/TextContext';
import { formatDate } from '../utils/date';
import LoadingPage from './LoadingPage';

export default function InvoicePage() {
    const { token, organization, loading } = useShareToken();
    const text = useText();

    const [invoice] = useFirebaseDoc<Invoice>(token && `${COLLECTIONS.ORGANIZATIONS}/${token?.orgId || ''}/${COLLECTIONS.DEALS}/${token?.dealId || ''}/${COLLECTIONS.INVOICES}/${token?.invoiceId || ''}`);
    const [deal] = useFirebaseDoc<Deal>(token && `${COLLECTIONS.ORGANIZATIONS}/${token?.orgId}/${COLLECTIONS.DEALS}/${token?.dealId}`)

    if (!deal || !invoice || loading || !organization) {
        return <LoadingPage />
    }

    return (
        <UnAuthOrganizationContextProvider organization={organization} orgId={token?.orgId || ''}>
            <div className='bg-body'>
                <div className='bg-offer position-relative'>
                    <Container className="d-flex flex-column gap-4 pt-5 pb-5">
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className="m-0">{text.invoice} {invoice.invoiceNumber ? `#${invoice.invoiceNumber}` : ''}</h4>
                            <InvoiceState invoice={invoice} />
                        </div>

                        <OrgCustomerCard deal={deal} showPaymentInstructions />

                        <div className="d-flex gap-4 flex-wrap">
                            {invoice.dueAt && (
                                <div>
                                    <div className="fw-semibold">{text.dueDate}</div>
                                    <div>{formatDate(invoice.dueAt, { noTime: true })}</div>
                                </div>
                            )}
                            {invoice.periodStart && invoice.periodEnd && (
                                <div>
                                    <div className="fw-semibold">{text.period}</div>
                                    <div>{formatDate(invoice.periodStart, { noTime: true })} - {formatDate(invoice.periodEnd, { noTime: true })}</div>
                                </div>
                            )}
                        </div>

                        {invoice.notes && (
                            <div>
                                <div className="fw-semibold">{text.notes}</div>
                                <div style={{ whiteSpace: 'pre-wrap' }}>{invoice.notes}</div>
                            </div>
                        )}

                        <LineItemsEditor lineItems={invoice.lineItems || []} onLineItemsChange={() => { }} readOnly />
                    </Container>
                </div>
            </div>
        </UnAuthOrganizationContextProvider>
    )
}
